import * as angular from 'angular';

/**
 * Created by STHOLLY on 12.08.2015.
 */
(function () {
    'use strict';

    angular.module('app').factory('TraderList', TraderListFactory);

    /**
     * Service for using REST-Service for TradingLists
     * @param $resource
     * @param API_URL configured in app.js
     * @returns Methods for GET, POST and DELETE of TradingLists
     */
    function TraderListFactory($resource, API_URL) {
        return $resource(
            API_URL.TRADER_LISTS,
            {},
            {
                publicQuery: {
                    method: 'GET',
                    url: API_URL.TRADER_LISTS + 'public',
                    params: { start: '@start', pageSize: '@pageSize' }
                },
                specificQuery: {
                    method: 'GET',
                    url: API_URL.TRADER_LISTS + 'traderLists',
                    params: { start: '@start', pageSize: '@pageSize' },
                    isArray: true
                },
                save: {
                    method: 'POST',
                    url: API_URL.TRADER_LISTS + 'traderLists'
                },
                delete: {
                    method: 'DELETE',
                    url: API_URL.TRADER_LISTS + 'traderLists/:traderListName',
                    params: { traderListName: '@traderListName' }
                }
            }
        );
    }
})();
